import React from 'react'
import axios from 'axios'
import {
	Row,
	Col,
	Form,
	Input,
	Button,
	Table,
	Affix,
	Dropdown,
	Menu,
	Icon,
} from 'antd'

import apiPath from 'apiPath'
import stickyError from 'components/stickyError'
import withSpin from 'components/withSpin'

class UserSearchDisplay extends React.Component {
	state = {
		searchResults: [],
		searchError: false,
		approvedPassports: [],
	}
	clearUser = () => {
		this.props.onUserChange(null)
	}

	handleMenuClick = (e) => {
		let newResult = this.state.searchResults.filter(
			(result) => result.SRI_VOYAGE_ID === e.key
		)
		if (newResult.length === 0)
			stickyError(
				'Please select which list to filter from first(passports, transcripts, ect.)'
			)
		this.setState({
			searchResults: newResult,
			searchError: false,
		})
		this.props.isDoneLoading()
	}

	handleLoadResults = (result) => {
		if (result.data.length === 0) stickyError('No results found')
		this.setState({
			searchResults: result.data,
			searchError: false,
		})
		this.props.isDoneLoading()
	}

	handleSubmit = (event) => {
		event.preventDefault()
		this.props.isLoading()
		this.props.form.validateFields((errors, values) => {
			axios
				.get(apiPath + '/folio/search', {
					withCredentials: true,
					params: values,
				})
				.then(this.handleLoadResults)
				.catch(this.handleError)
		})
	}
	getUnapprovedPassports = (event) => {
		axios
			.get(apiPath + '/getUnapprovedPassports', { withCredentials: true })
			.then(this.handleLoadResults)
			.catch(this.handleError)
	}
	getUnapprovedPassportPhotos = (event) => {
		axios
			.get(apiPath + '/getUnapprovedPassportPhotos', {
				withCredentials: true,
			})
			.then(this.handleLoadResults)
			.catch(this.handleError)
	}
	getUnapprovedTranscripts = (event) => {
		axios
			.get(apiPath + '/getUnapprovedTranscripts', {
				withCredentials: true,
			})
			.then(this.handleLoadResults)
			.catch(this.handleError)
	}

	getUnapprovedMedicalRecords = (event) => {
		axios
			.get(apiPath + '/getUnapprovedMedicalRecords', {
				withCredentials: true,
			})
			.then(this.handleLoadResults)
			.catch(this.handleError)
	}
	handleRowClick = (record, index, event) => {
		this.props.onUserChange(record)
	}
	handleError = (error) => {
		this.props.isDoneLoading()
		console.error(error)
		if (error.response.status === 401) {
			this.props.kickSession()
			stickyError('Your session has timed out')
		} else {
			const message =
				error.response && error.response.statusText
					? error.response.statusText
					: error.message
			stickyError('Request failed: ' + message)
		}
		localStorage.setItem('redirectAfterLogin', window.location.hash)
		localStorage.setItem('currentUser', JSON.stringify(null))
		this.setState({
			currentUser: null,
			searchError: true,
		})
	}

	render() {
		const { getFieldDecorator } = this.props.form
		const currentUser = this.props.currentUser

		const menu = (
			<Menu onClick={this.handleMenuClick}>
				{this.props.voyages.map((voyage) => {
					return (
						<Menu.Item key={voyage.id}>
							<Icon type='user' />
							{voyage.name}
						</Menu.Item>
					)
				})}
			</Menu>
		)

		return (
			<div>
				<Affix>
					{currentUser !== null && (
						<div
							style={{
								backgroundColor: 'white',
								padding: '12pt',
							}}
						>
							<Button
								onClick={this.clearUser}
								type='primary'
								icon='search'
								style={{ float: 'right', marginTop: '-2pt' }}
							>
								Switch Voyager
							</Button>
							<h3>
								{currentUser.folForeName +
									' ' +
									currentUser.folSurName +
									' (' +
									currentUser.folRepeaterNo +
									')'}
							</h3>
						</div>
					)}

					{currentUser == null && (
						<div>
							<Button
								onClick={this.getUnapprovedPassports}
								type='primary'
								icon='search'
								style={{ marginTop: '2pt', marginLeft: '14pt' }}
							>
								List Unapproved Passports
							</Button>

							<Button
								onClick={this.getUnapprovedPassportPhotos}
								type='primary'
								icon='search'
								style={{ marginTop: '2pt', marginLeft: '14pt' }}
							>
								List Unapproved Passport Photos
							</Button>

							<Button
								onClick={this.getUnapprovedTranscripts}
								type='primary'
								icon='search'
								style={{ marginTop: '2pt', marginLeft: '14pt' }}
							>
								List Unapproved Transcripts
							</Button>
							<Button
								onClick={this.getUnapprovedMedicalRecords}
								type='primary'
								icon='search'
								style={{ marginTop: '2pt', marginLeft: '14pt' }}
							>
								List Unreceived Medical Records
							</Button>
							<Dropdown overlay={menu}>
								<Button
									style={{
										marginTop: '2pt',
										marginLeft: '14pt',
									}}
								>
									Filter By Voyage <Icon type='down' />
								</Button>
							</Dropdown>
						</div>
					)}

					{currentUser === null && (
						<div style={{ padding: '12pt' }}>
							<Form onSubmit={this.handleSubmit}>
								<Row>
									<Col xs={7}>
										<Form.Item>
											{getFieldDecorator(
												'Forename',
												{}
											)(
												<Input placeholder='First Name' />
											)}
										</Form.Item>
									</Col>
									<Col xs={7}>
										<Form.Item>
											{getFieldDecorator(
												'Surname',
												{}
											)(
												<Input placeholder='Last Name' />
											)}
										</Form.Item>
									</Col>
									<Col xs={7}>
										<Form.Item>
											{getFieldDecorator(
												'RepeaterNo',
												{}
											)(<Input placeholder='Resco ID' />)}
										</Form.Item>
									</Col>
									<Col xs={3}>
										<Button
											type='primary'
											size='large'
											htmlType='submit'
											icon='search'
											style={{ width: '100%' }}
										/>
									</Col>
								</Row>
							</Form>
						</div>
					)}
				</Affix>
				{currentUser === null && (
					<Table
						style={{ backgroundColor: 'white', margin: '0 8pt' }}
						pagination={true}
						dataSource={this.state.searchResults}
						rowKey={'folRepeaterNo'}
						onRowClick={this.handleRowClick}
						columns={[
							{
								title: 'First Name',
								dataIndex: 'folForeName',
								key: 'ForeName',
							},
							{
								title: 'Last Name',
								dataIndex: 'folSurName',
								key: 'SurName',
							},
							{
								title: 'Resco ID',
								dataIndex: 'folRepeaterNo',
								key: 'RepeaterNo',
							},
						]}
					/>
				)}
			</div>
		)
	}
}

export default Form.create()(withSpin(UserSearchDisplay))



// WEBPACK FOOTER //
// ./portal-components/UserSearchDisplay/index.jsx